export const domain = window.location.origin;
export const SsoHome = '/SSO';
export const IOT = '/Iot';
export const Autmation = '/Automation';
export const Citizen = '/Citizen'
export const Cms = '/Cms'
export const em = '/em'
